import { useMutation } from '@provision/graphql-client';
import { COPY_ACTIVATION_FLOW_CONFIG_MUTATION } from 'src/graphql/entities/activation-flow-config/activation-flow-config.operations';
import type {
  CopyActivationFlowConfigMutationData,
  CopyActivationFlowConfigMutationVariables,
} from 'src/graphql/entities/activation-flow-config/activation-flow-config.types';

export const useCopyActivationFlowConfig = () => {
  const [copyActivationFlowConfig, { data, loading, error }] = useMutation<
    CopyActivationFlowConfigMutationData,
    CopyActivationFlowConfigMutationVariables
  >(COPY_ACTIVATION_FLOW_CONFIG_MUTATION);

  return {
    copyActivationFlowConfig,
    data,
    loading,
    error,
  };
};
